import Image from 'next/image';

import styles from './index.module.scss';

export const OfferItem = ({ icon, title, value }) => {
  return (
    <div className={styles.offer} itemScope itemType='https://schema.org/Offer'>
      <div className={styles.iconHolder}>
        <Image src={icon} width={24} height={24} alt={title} title={title} />
      </div>
      <div className={styles.texts}>
        <p>{title}</p>
        <p>{value}</p>
      </div>
    </div>
  );
};
